import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueMask from 'v-mask'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Vue.config.productionTip = false
Vue.use(VueMask);

Sentry.init({
  Vue,
  dsn: "https://291d362a2e6a4a8f9da0e27a89819b7d@o345061.ingest.sentry.io/6289894",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["local-portal.dutchbros.com/api", "portal.dutchbros.com/api"],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

import './styles/style.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'mapbox-gl/dist/mapbox-gl.css'; 

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
